<script lang="ts">
  import Modal from '../Modal.svelte';
  import Text from '../Text.svelte';
  import Button from '../Button.svelte';

  export let isOpen: boolean;
  export let onDelete: () => void;
</script>

<Modal size="small" label="Weiterleitung löschen" bind:isOpen>
  <Text size="medium">Möchten Sie die Weiterleitung wirklich löschen?</Text>

  <svelte:fragment slot="button">
    <Button on:click={() => (isOpen = false)}>Abbrechen</Button>
    <Button
      on:click={() => {
        isOpen = false;
        onDelete();
      }}
      variant="primary">Löschen</Button
    >
  </svelte:fragment>
</Modal>
